import React from 'react'

const Heading = ({
  children
}) => {
  return (
    <div className="text-lg font-semibold text-gray-800 mb-4">
      {children}
    </div>
  );
}

export default Heading